import axios from 'axios';
import { SubOrganization } from './SubOrganizationUtils';
import { SurveyParticipation, Question } from './SurveyUtils';
import { PointsOfService } from './PointsOfServiceUtils';

interface HumanResourcePlan {
  id?: number;
  suborganization?: Partial<SubOrganization>;
  pointsofservice?: Partial<PointsOfService>;
  surveyparticipation: Partial<SurveyParticipation>;
  question: Partial<Question>;
  department?: string;
  position?: string;
  positioncount?: any; // JSON, based on the type
}

const api = {
  list: async (params?: {
    questionid: number;
    surveyparticipationid: number;
  }) => {
    const resp = await axios.get<HumanResourcePlan[]>(
      '/humanResources/list.php',
      {
        params: params,
      }
    );
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<HumanResourcePlan>('/humanResources/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (humanresourceplans: HumanResourcePlan[]) => {
    const resp = await axios.post<number[]>('/humanResources/add.php', {
      humanresourceplans: humanresourceplans,
    });
    humanresourceplans = humanresourceplans.map((humanresourceplan, index) => ({
      ...humanresourceplan,
      id: resp.data[index],
    }));
    return humanresourceplans;
  },

  update: async (humanresourceplan: Partial<HumanResourcePlan>) => {
    await axios.post('/humanResources/update.php', humanresourceplan);
  },

  remove: async (id: number) => {
    await axios.delete('/humanResources/delete.php', {
      params: { id: id },
    });
  },
};

export default {
  api,
};

export { HumanResourcePlan };
